import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IdTitleDropdown, IIdTitleDropdownItem } from "ui/Scripts/source/components/framework/Dropdown/IdTitleDropdown";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { ITaskTypeChart } from "ui/Scripts/source/models/task/taskTypeChart";
import { getTaskChartDesignerChartTitle } from "../ChartDesignerChartPicker";

interface IChartDesignerChartPropertiesNameProps {
    taskType: ITaskEditTypeItem;
    selectedTaskTypeChart: ITaskTypeChart;
    onChartClick: (name: string) => void;
}

export const ChartDesignerChartPropertiesName = (props: IChartDesignerChartPropertiesNameProps) => {
    const [dropdownItems, setDropdownItems] = useState<IIdTitleDropdownItem[]>([]);

    const getDropDownTitle = (chart: ITaskTypeChart) => {
        let title = chart.title ? chart.title : "";
        if (title.length > 20) {
            title = title.substring(0, 20).trim() + "...";
        }
        const titleStr = title ? ` (${title})` : "";
        return `${getTaskChartDesignerChartTitle(chart.taskChartType)}${titleStr}`;
    };

    useEffect(() => {
        const newDropdownItems: IIdTitleDropdownItem[] = [];
        props.taskType.charts.forEach((chart) => {
            newDropdownItems.push({
                id: chart.name,
                title: getDropDownTitle(chart)
            });
        });
        setDropdownItems(newDropdownItems);
    }, [props.taskType?.charts]);

    if (!props.taskType?.charts) return null;
    
    return (
        <Box sx={{ paddingLeft: "16px", paddingRight: "16px", paddingBottom: "8px", fontSize: "14px" }}>
            <IdTitleDropdown
                selectedId={props.selectedTaskTypeChart?.name}
                items={dropdownItems}
                onChange={props.onChartClick}
            />
        </Box>
    );
};
